import React from 'react';

import { DateValueFormatter } from '@gogame/intl-ts';
import { Card, CardContent } from '@gogame/ui/Card';
import Stack from '@gogame/ui/Stack';

import Typography from '@gogame/ui/Typography';
import { makeStyles, alpha } from '@gogame/ui/styles';

import { HTMLRender } from '../../RichText';
import CommentHeader from './CommentHeader';
import CommentRating from './CommentRating';

const useStyles = makeStyles((theme) => ({
  chipHolder: {
    marginLeft: '-4px !important',
  },
  card: {
    background: alpha(
      theme.palette.action.active,
      theme.palette.action.hoverOpacity
    ),
    height: '100%',
    padding: '4px 0',
  },
}));

const CommentPreview = ({
  author,
  date,
  mark,
  message,
  onEdit,
  onDelete,
  withActions,
  dataCy = 'Message',
}) => {
  const classes = useStyles();

  return (
    <Card data-cy={dataCy} className={classes.card} outlined={false}>
      <CommentHeader
        withActions={withActions}
        subheader={
          <>
            {author && (
              <Typography
                data-cy={'MessageAuthor'}
                variant={'body1'}
                bold={true}
              >
                {author}
              </Typography>
            )}
            {!author && message && (
              <Typography variant={'body1'}>{message}</Typography>
            )}
          </>
        }
        onEdit={onEdit}
        onDelete={onDelete}
        message={
          <Stack direction={'row'} spacing={1}>
            {date && (
              <Typography
                data-cy={'MessageDate'}
                color={'textSecondary'}
                variant={'body1'}
              >
                <DateValueFormatter
                  value={date}
                  template={'LLL'}
                  timeZone={'local'}
                />
              </Typography>
            )}
            {mark && <CommentRating mark={mark} />}
          </Stack>
        }
      />

      {author && message && (
        <CardContent>
          <Stack direction={'column'} spacing={2}>
            {author && message && (
              <Typography variant={'body1'}>
                <HTMLRender value={message} />
              </Typography>
            )}
          </Stack>
        </CardContent>
      )}
    </Card>
  );
};
export default CommentPreview;
